// Insight `type` strings — must match the backend rule names in
// backend/routers/insights.py exactly. Defined once; never inline a literal.
// Lives in its own module (not Dashboard.js) so both Dashboard and the shared
// useTruflowData hook can import it without a circular dependency.
export const INSIGHT_TYPES = {
  DEDUCTION_RUNNING_TOTAL: 'deduction_running_total',
  SLOW_SEASON_RUNWAY:      'slow_season_runway',
  NEGATIVE_MONTH_MOVE:     'negative_month_move',
  DEADLINE_PACE:           'deadline_pace',
};
